export default {"src":"/_next/static/media/slide-next.f57fd694.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};